import { Component, OnInit } from '@angular/core';
import { UserService } from '../../services/user/user.service';
import { AppearanceService } from '../../services/appearance/appearance.service';
import { AlertController, ModalController } from '@ionic/angular';
import { JobService } from 'src/app/services/job/job.service';
import { ClientService } from 'src/app/services/client/client.service';
import { AssetService } from 'src/app/services/asset/asset.service';
import { FilterModel } from 'src/app/models/filter.model';
import { ReportModel } from 'src/app/models/report.model';
import { Constants } from 'src/app/constants/constants';
import { ReportService } from 'src/app/services/report/report.service';


@Component({
  selector: 'modal-report-where',
  templateUrl: './modal-report-where.component.html',
  styleUrls: ['./modal-report-where.component.scss'],
})
export class ModalReportWhereComponent implements OnInit {

  theList: Array<FilterModel>;
  otherList: Array<FilterModel>;
  selectedList: Array<any>;
  whereCriteria: string;
  currentReport: ReportModel = null;
  limit;

  constructor(public appearanceService: AppearanceService,
   public userService: UserService, public modalControllerTwo: ModalController, 
   public jobService: JobService, public clientService: ClientService,
   public assetService: AssetService, public reportService: ReportService,
   private alertController: AlertController) {

  }


  ngOnInit() 
  {

  }


  ionViewWillEnter()
  {
    //this.selectedList = [];

    switch(this.whereCriteria)
    {
      case 'users':
      case 'engineers':
      case 'managers':
        this.getListOfUsers();
        break;

      case 'assetType':
        this.getListOfAssetTypes();
        break;

        /*
      case 'assetConditionCode':
        this.getListOfAssetConditionCodes();
        break;

      case 'assetCondition':
        this.getListOfAssetConditions();
        break;

      case 'headType':
        this.getListOfHeadTypes();
        break;

      case 'columnType':
        this.getListOfColumnTypes();
        break;
        */

      case 'stlPreset':
        this.getListOfStlPresets();
        break;

      case 'locations':
        this.getListOfLocations();
        break;

      case 'jobstatus':
        this.getListOfJobStatuses();
        break;

      case 'jobType':
        this.getListOfJobTypes();
        break;
    }
  }


  ionViewDidLeave()
  {
   
  }


  getListOfUsers()
  {
    this.theList = new Array<FilterModel>();

    this.appearanceService.showLoading("Please wait...").then(() => {

      this.clientService.getListOfUsers().subscribe(response => {
        
        this.appearanceService.dismissLoading();

        if (response.Success)
        {
          for (var i = 0; i < response.Users.length; i++)
          {
            var item      = new FilterModel();
            item.uid      = response.Users[i].uid;
            item.name     = response.Users[i].name;
            item.selected = false;

            for (var x = 0; x < this.selectedList.length; x++)
            {
              if (this.selectedList[x] == item.uid)
              {
                this.selectedList[x] = item;
                this.selectedList[x].selected = true;
              }
            }

            this.theList.push(item);
          }
        }
        else
        {
          this.appearanceService.presentToast(response.Message, Constants.TOAST_ERROR);
        }
      },
      err => {

        this.appearanceService.dismissLoading();
        this.appearanceService.presentToast(err, Constants.TOAST_ERROR);
      });
    });
  }


  getListOfAssetTypes()
  {
    this.theList = new Array<FilterModel>();

    this.appearanceService.showLoading("Please wait...").then(() => {

      this.clientService.getListOfAssetTypes().subscribe(response => {
        
        this.appearanceService.dismissLoading();

        if (response.Success)
        {
          for (var i = 0; i < response.AssetTypes.length; i++)
          {
            var item      = new FilterModel();
            item.uid      = response.AssetTypes[i].uid;
            item.name     = response.AssetTypes[i].name;
            item.selected = false;

            for (var x = 0; x < this.selectedList.length; x++)
            {
              if (this.selectedList[x] == item.uid)
              {
                this.selectedList[x] = item;
                this.selectedList[x].selected = true;
              }
            }

            this.theList.push(item);
          }
        }
        else
        {
          this.appearanceService.presentToast(response.Message, Constants.TOAST_ERROR);
        }
      },
      err => {

        this.appearanceService.dismissLoading();
        this.appearanceService.presentToast(err, Constants.TOAST_ERROR);
      });
    });
  }


  getListOfLocations()
  {

  }


  getListOfJobStatuses()
  {
    var statuses = this.clientService.getClientJobStatusFilters();

    this.theList = new Array<FilterModel>();

    for (var i = 0; i < statuses.length; i++)
    {
      var item = new FilterModel();
      item.uid = statuses[i].uid;
      item.name = statuses[i].name;
      item.selected = false;

      for (var x = 0; x < this.selectedList.length; x++)
      {
        if (this.selectedList[x] == item.uid)
        {
          this.selectedList[x] = item;
          this.selectedList[x].selected = true;
        }
      }

      this.theList.push(item);
    }
  }


  getListOfJobTypes()
  {
    var jobTypes = this.clientService.getJobTypes();

    this.theList = new Array<FilterModel>();

    for (var i = 0; i < jobTypes.length; i++)
    {
      var item = new FilterModel();
      item.uid = jobTypes[i].uid;
      item.name = jobTypes[i].name;
      item.selected = false;

      for (var x = 0; x < this.selectedList.length; x++)
      {
        if (this.selectedList[x] == item.uid)
        {
          this.selectedList[x] = item;
          this.selectedList[x].selected = true;
        }
      }

      this.theList.push(item);
    }
  }


  /*
  getListOfAssetConditionCodes()
  {
    this.theList = new Array<FilterModel>();

    var conditions = ["S", "C1", "C2", "C3", "FI"];

    for (var i = 0; i < conditions.length; i++)
    {
      var item = new FilterModel();
      item.name = conditions[i];
      item.selected = false;

      for (var x = 0; x < this.selectedList.length; x++)
      {
        if (this.selectedList[x] == item.name)
        {
          item.selected = true;
        }
      }

      this.theList.push(item);
    }
  }


  getListOfAssetConditions()
  {
    this.theList = new Array<FilterModel>();

    var conditions = ["Excellent", "Good", "Fair", "Poor"];

    for (var i = 0; i < conditions.length; i++)
    {
      var item = new FilterModel();
      item.name = conditions[i];
      item.selected = false;

      for (var x = 0; x < this.selectedList.length; x++)
      {
        if (this.selectedList[x] == item.name)
        {
          item.selected = true;
        }
      }

      this.theList.push(item);
    }
  }


  getListOfHeadTypes()
  {
    this.theList = new Array<FilterModel>();

    var conditions = ["Son", "Beta Style", "Gamma6", "Solar"];

    for (var i = 0; i < this.currentReport.whereHeadType.length; i++)
    {
      if(!conditions.includes(this.currentReport.whereHeadType[i]))
      {
        conditions.push(this.currentReport.whereHeadType[i])
      }
    }

    for (var i = 0; i < conditions.length; i++)
    {
      var item = new FilterModel();
      item.name = conditions[i];
      item.selected = false;

      for (var x = 0; x < this.selectedList.length; x++)
      {
        if (this.selectedList[x] == item.name)
        {
          item.selected = true;
        }
      }

      this.theList.push(item);
    }
  }


  getListOfColumnTypes()
  {
    this.theList = new Array<FilterModel>();

    var conditions = ["Steel", "Concrete", "Aluminium"];

    for (var i = 0; i < this.currentReport.whereColumnType.length; i++)
    {
      if(!conditions.includes(this.currentReport.whereColumnType[i]))
      {
        conditions.push(this.currentReport.whereColumnType[i])
      }
    }

    for (var i = 0; i < conditions.length; i++)
    {
      var item = new FilterModel();
      item.name = conditions[i];
      item.selected = false;

      for (var x = 0; x < this.selectedList.length; x++)
      {
        if (this.selectedList[x] == item.name)
        {
          if(item.name == "Other")
          {

          }
          item.selected = true;
        }
      }

      this.theList.push(item);
    }
  }
  */


  getListOfStlPresets()
  {
    this.theList = new Array<FilterModel>();
    
    var assetTypesSelected = this.currentReport.whereAssetTypeUids;

    var payload = {
      clientUid: this.clientService.getClientUid(),
      organisationUid: this.clientService.getOrganisationUid(),
      whereAssetTypeUids: assetTypesSelected
    }

    this.appearanceService.showLoading("Please wait...").then(() => {

      this.reportService.getStlPresetsForReport(payload).subscribe(response => {
    
        this.appearanceService.dismissLoading();

        if (response.Success)
        {
          
          for (var i = 0; i < response.StlPresets.length; i++)
          {
            var item = new FilterModel();
            item.uid = response.StlPresets[i].presetUid;
            item.name = response.StlPresets[i].presetName;
            item.selected = false;
      
            for (var x = 0; x < this.selectedList.length; x++)
            {
              if (this.selectedList[x] == item.uid)
              {
                this.selectedList[x] = item;
                this.selectedList[x].selected = true;
              }
            }
      
            this.theList.push(item);
          }
        }
        else
        {
          this.appearanceService.presentToast(response.Message, Constants.TOAST_ERROR);
        }
      },
      err => {

        this.appearanceService.dismissLoading();
        this.appearanceService.presentToast(err, Constants.TOAST_ERROR);

      });
    }); 
  }


  selected(choice)
  {
    var foundSelectedIndex = -1;

    if (this.whereCriteria == 'assetCondition' || this.whereCriteria == 'assetConditionCode' || this.whereCriteria == 'headType' || this.whereCriteria == 'columnType')
    {
      if (choice.name == "Other")
      {
        this.otherSelected("unknown");
        return;
      }
    }

    for (var i = 0; i < this.selectedList.length; i++)
    {
      
      if (this.selectedList[i].uid == choice.uid)
      {
        foundSelectedIndex = i;
        break;
      }

      if (this.selectedList[i] == choice.uid)
      {
        foundSelectedIndex = i;
        break;
      }
    }

    if (foundSelectedIndex < 0)
    {
      // We have selected an entry.
      choice.selected = true;
      this.selectedList.push(choice);

      if (this.limit == 1)
      {
        this.save();
      }
    }
    else
    {
      // We have unselected an entry, remove it from our selected list.
      choice.selected = false;
      this.selectedList.splice(foundSelectedIndex, 1);
    }

    if (!this.selectedList.length)
    {
      this.selectedList = [];
    }
  }


  async otherSelected(title)
  {
    if(this.whereCriteria == "headType")
    {
      title = 'Enter other head type';
    }

    if(this.whereCriteria == "columnType")
    {
      title = 'Enter other column type';
    }

    let alert = await this.alertController.create({
      header: title,
      inputs: [
        {
          name: 'otherValue',
          placeholder: '',
          type: 'text'
        },
      ],
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          handler: data => {
            
          }
        },
        {
          text: 'Add Filter',
          handler: data => {

            var foundIndex = -1;

            for (var i = 0; i < this.selectedList.length; i++)
            {
              if (this.selectedList[i] == data.otherValue)
              {
                foundIndex = i;
                break;
              }
            }
        
            if (foundIndex < 0)
            {
              var item = new FilterModel();
              item.name = data.otherValue;
              item.selected = true;

              this.theList.push(item);
              this.selectedList.push(data);
            }
            else
            {
              this.theList[foundIndex].selected = false;
              this.selectedList.splice(foundIndex, 1);
            }
        
            if (!this.selectedList.length)
            {
              this.selectedList = [];
            }
          }
        }
      ]
    });

    await alert.present();
  }


  save()
  {
    var returnData = { selected: this.selectedList };
    this.modalControllerTwo.dismiss(returnData, null, 'ReportWhereModal');
  }


  closeModal(returnData = null)
  {
    this.modalControllerTwo.dismiss(null, null, 'ReportWhereModal');
  }
}
